'use strict';

angular.module('shiftTraderApp')
  .service('UtilityService', ['Session', function (Session) {

    function identityFn(x) {
      return x;
    }

    function inverseIdentityFn(x) {
      return !x;
    }


    var calcColorWithGoal = function(goal, actual, greenPerc, redPerc) {
      var percBelow = goal * greenPerc / 100;
      var percAbove = goal * redPerc / 100;
      var midpoint = (percAbove + percBelow) / 2;
      var dist = midpoint - percBelow;

      var actualLow = actual < percBelow;
      var actualHigh = actual > percAbove;
      var inLowerBand = !actualLow && !actualHigh && actual <= midpoint;
      var inUpperBand = !actualLow && !actualHigh && actual > midpoint;

      var green = '#84ba6a'; // $shiftGreen
      var orange = '#ff9035'; // $shiftOrange
      var red = tinycolor('#A73434').lighten(10).toString(); //$shiftRouge lightened 10%
      var setColor;
      var temp = null;

      if ( actualLow ) {
        setColor = green;
      } else if ( inLowerBand ) {
        temp = (midpoint - actual) / dist * 100;
        setColor = tinycolor.mix(orange, green, temp).toString();
      } else if ( inUpperBand ) {
        temp = (actual - midpoint) / dist * 100;
        setColor = tinycolor.mix(orange, red, temp).toString();
      } else {
        setColor = red;
      }
      return setColor;
    };


    var calcClassDiff = function(currentClassDict, newClassDict) {
      // given:
      //var currentClassDict = {
      //  x: false,
      //  y: true,
      //  z: true,
      //  q: false
      //};
      //
      //var newClassDict = {
      //  x: true,
      //  y: true,
      //  z: false,
      //  q: true
      //};

      // returns:
      //{
      //  add: 'x q',
      //  remove: 'z'
      //}


      return {
        add: _.difference(_.keys(_.pick(newClassDict, identityFn)), _.keys(_.pick(currentClassDict, identityFn))).join(' '),
        remove: _.difference(_.keys(_.pick(newClassDict, inverseIdentityFn)), _.keys(_.pick(currentClassDict, inverseIdentityFn))).join(' ')
      };
    };

    return {
      calcColorWithGoal: calcColorWithGoal,
      calcClassDiff: calcClassDiff
    };

  }]);
